import { Box } from "@origin-digital/ods-core";
import styled from "styled-components";

export const QuickLinkStyles = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr", // Default: 1 column
  gap: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "1fr 1fr", // On 'sm' breakpoint: 2 columns
  },
  [theme.breakpoints.up("lg")]: {
    gridTemplateColumns: "1fr 1fr 1fr", // On 'lg' breakpoint: 3 columns
  },

  "& h3 a ": {
    textDecoration: "none",
  },

  "& ul": {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },

  "& li": {
    listStyle: "none",
    marginBottom: 12,
  },

  // does this do anything??
  quickLink: {
    textDecoration: "none",
  },
}));
